import React from "react";
import { AllIconNames } from "react-ui";

import { useCandyTheme } from "../../../Internals/ThemeProvider/CandyTheme/UseCandyTheme";
import { Icon } from "../../../Icons/Icon";

import { MenuActionLink, MenuActionText, MenuActionButton } from "./MenuAction.styles";

interface MenuActionProps {
    icon: AllIconNames | "";
    href?: string;
    text: string;
    onClick?: (event: React.SyntheticEvent) => void;
    children?: React.ReactNode;
    disabled?: boolean;
    download?: boolean;
}

export const MenuAction = (props: MenuActionProps) => {
    const theme = useCandyTheme();

    const { download, icon, text, disabled } = props;

    const handleOnClick = (event: React.SyntheticEvent) => {
        if (disabled) {
            return;
        }
        props.onClick?.(event);
    };

    if (props.href != undefined) {
        return (
            <MenuActionLink
                rel="noreferrer"
                href={props.href}
                target="_blank"
                disabled={disabled}
                download={download}
                onClick={handleOnClick}>
                {icon !== "" && <Icon name={icon} size={theme.typography.primary.fontSize.getNumber()} />}
                <MenuActionText>{text}</MenuActionText>
            </MenuActionLink>
        );
    }

    return (
        <MenuActionButton type="button" disabled={disabled} onClick={handleOnClick}>
            {icon !== "" && <Icon name={icon} size={theme.typography.primary.fontSize.getNumber()} />}
            <MenuActionText>{text}</MenuActionText>
        </MenuActionButton>
    );
};
